var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pag"},[_c('a-pagination',{attrs:{"show-quick-jumper":"","current":_vm.pageNumber,"default-current":1,"total":_vm.showTotal},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }